import styled from "styled-components";
import { baseColors } from "../../../../../themes/definitions/casino888/cip/base-colors";
import { MiniOrbitNavbarWrapperDefaultBox } from "./mini-orbit-navbar-wrapper.default.box";

export const MiniOrbitNavbarWrapperCipBox = styled(MiniOrbitNavbarWrapperDefaultBox)`
    background-color: ${baseColors.black};
`;